import { Type } from '@angular/core';
import { Observable } from 'rxjs';

export abstract class StorageService {
    public abstract clear(): void;
    public abstract put<T>(key: string, data: T): Observable<T>;
    public abstract get(key: string): Observable<any>;
    public abstract get<T>(key: string, ctor?: Type<T>): Observable<T>;
}
